export const NEW_ATHLETE_FLOW = Object.freeze({
  /** `onboarding/continue` is the entry point since we are leveraging legacy endpoint redirects.
   * We will be able to change this only after we stop depending on the current backend
   * implementation for determining when to redirect athletes back to the onboarding flow.
   *
   * See OnboardingController#continue
   *
   * IMPORTANT - accounts registered using fb and google start the flow with
   * /google_registered and /facebook_registered (and not /continue)
   * These legacy routes are mapped to reuse the same step as /continue and
   * maintain underscore case in the url.
   * */
  createProfile: 'continue',
  googleRegistered: 'google_registered',
  facebookRegistered: 'facebook_registered',
  suggestedFriends: 'suggested_friends', // legacy path - https://github.com/strava/active/blob/583a84e4d54bec7087d0a8ad5ebe8e762ad02a45/app/controllers/onboarding_controller.rb
  facebookFriends: 'facebook_friends', // legacy path - https://github.com/strava/active/blob/583a84e4d54bec7087d0a8ad5ebe8e762ad02a45/app/controllers/onboarding_controller.rb
  welcome: 'welcome_to_strava', // onboarding/welcome url is already being used by the legacy flow
  subscriptionTrial: 'subscription_trial',
  directPromotion: 'direct_promotion'
});

export const EXISTING_ATHLETE_FLOW = Object.freeze({
  welcome: 'welcome',
  termsOfService: 'terms_of_service',
  privacyPolicy: 'privacy_policy',
  directPromotion: NEW_ATHLETE_FLOW.directPromotion, // shared step
  health: 'health',
  health_denial_one: 'health_denial_one',
  health_denial_two: 'health_denial_two',
  all_set: 'all_set',
  ageConfirmation: 'age_confirmation'
});

export const CATEGORIES = Object.freeze({
  newAthlete: 'new_athlete',
  existingAthlete: 'existing_athlete'
});

export const INPUT_IDS = Object.freeze({
  firstName: 'firstName',
  lastName: 'lastName',
  birthday: 'birthday',
  month: 'month',
  day: 'day',
  year: 'year',
  gender: 'gender'
});
